/* esm.sh - @internetarchive/ia-userlist-settings@1.1.2 */
import{__decorate as p,__metadata as b}from"/tslib?target=es2022";import{html as F,css as R,LitElement as D}from"/lit@^2.8.0?target=es2022";import{property as T,customElement as M,query as f}from"/lit@^2.8.0/decorators?target=es2022";import{css as o}from"/lit@^2.8.0?target=es2022";var L=o`var(--white, #fff)`,x=o`var(--primaryDisableCTAFill, #767676)`,w=o`var(--secondaryCTABorder, #999)`,C=o`var(--primaryCTAFill, #194880)`,g=o`var(--primaryCTAFillRGB, 25, 72, 128)`,B=o`var(--primaryCTABorder, #c5d1df)`,k=o`var(--primaryErrorCTAFill, #d9534f)`,y=o`var(--primaryErrorCTAFillRGB, 229, 28, 38)`,S=o`var(--primaryErrorCTABorder, #d43f3a)`,_=o`var(--secondaryCTAFill, #333)`,E=o`var(--secondaryCTAFillRGB, 51, 51, 51)`,A=o`var(--primaryCTABorder, #979797)`,U=o`#ee8950`,O=o`#ec7939`,$=o`
  .ia-button {
    min-height: 3rem;
    cursor: pointer;
    color: ${L};
    line-height: normal;
    border-radius: 0.4rem;
    font-size: 1.4rem;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    border: 1px solid transparent;
    white-space: nowrap;
    appearance: auto;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    transition: all 0.1s ease 0s;
    vertical-align: middle;
    padding: 0 3rem;
    outline-color: ${L};
    outline-offset: -4px;
    user-select: none;
    text-decoration: none;
    width: fit-content;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
  }
  .ia-button:focus-visible {
    outline-style: double;
  }
  .ia-button:disabled {
    cursor: not-allowed;
    background-color: ${x};
    border: 1px solid ${w};
  }
  .ia-button.transparent {
    background-color: transparent;
  }
  .ia-button.warning {
    background-color: ${U}
    border-color: ${O};
  }

  .ia-button.primary {
    background-color: ${C};
    border-color: ${B};
  }
  .ia-button.primary:hover {
    background-color: rgba(${g}, 0.9);
  }
  .ia-button.primary:focus-visible {
    background-color: rgba(${g}, 0.8);
  }
  .ia-button.primary:active {
    background-color: rgba(${g}, 0.7);
  }

  .ia-button.danger {
    background-color: ${k};
    border-color: ${S};
  }
  .ia-button.danger:hover {
    background-color: rgba(${y}, 0.9);
  }
  .ia-button.danger:focus-visible {
    background-color: rgba(${y}, 0.8);
  }
  .ia-button.danger:active {
    background-color: rgba(${y}, 0.7);
  }

  .ia-button.dark {
    background-color: ${_};
    border-color: ${A};
  }
  .ia-button.dark:hover {
    background-color: rgba(${E}, 0.9);
  }
  .ia-button.dark:focus-visible {
    background-color: rgba(${E}, 0.8);
  }
  .ia-button.dark:active {
    background-color: rgba(${E}, 0.7);
  }
`;import{SearchType as N}from"/@internetarchive/search-service@^2.5.1?target=es2022";var u;(function(n){n.NETWORK="failed to connect to user lists backend service",n.BAD_RESPONSE="malformed response from backend",n.USER_NOT_FOUND="user with the given id was not found",n.LIST_NOT_FOUND="user list with the given id was not found",n.LIST_MEMBER_NOT_FOUND="user list member with the given id was not found",n.ITEM_NOT_TOUND="item with the given id was not found"})(u||(u={}));var m=class extends Error{constructor(e,t,r){super(t,r),this.reason=e}};var h="application/json; charset=utf-8",v=class n{constructor({fetchHandler:e,searchService:t,userService:r,baseUrl:i=n.DEFAULT_BASE_URL}){this.fetchHandler=e,this.searchService=t,this.userService=r,this.baseUrl=i}async fetchEndpoint(e,t,r,i){try{let s=await this.fetchHandler.fetchApiResponse(e,{method:t,body:r,headers:i,includeCredentials:!0});return s.success?{success:s.value}:{error:n.getErrorResult(u.LIST_NOT_FOUND,s.error)}}catch(s){return{error:n.getErrorResult(u.NETWORK,s)}}}async fetchListsForUser(e){var t;let r=(t=await this.userService.getLoggedInUser())===null||t===void 0?void 0:t.success,i=r?.itemname===e?"me":e;return this.fetchEndpoint(`${this.baseUrl}/services/users/${i}/lists`)}async fetchList(e,t){return this.fetchEndpoint(`${this.baseUrl}/services/users/${e}/lists/${t}`)}async fetchOwnListsContainingItem(e){return this.fetchEndpoint(`${this.baseUrl}/services/users/me/lists?item=${e}`)}async fetchListMembers(e,t){let r=await this.fetchList(e,t);if(!r.success)return r;let{members:i}=r.success;if(!i)throw n.getErrorResult(u.BAD_RESPONSE);return{success:i}}async fetchListMemberSearchResults(e,t){let r=await this.fetchListMembers(e,t);if(!r.success)return r;let i=r.success;if(i.length===0)return{success:[]};let s=`identifier:(${i.map(l=>l.identifier).join(" OR ")})`,a=await this.searchService.search({query:s,rows:i.length,aggregations:{omit:!0}},N.METADATA);return a.success?{success:a.success.response.results}:{error:a.error}}async createList(e){return this.fetchEndpoint(`${this.baseUrl}/services/users/me/lists`,"POST",JSON.stringify(e),{"Content-Type":h})}async updateList(e,t){return this.fetchEndpoint(`${this.baseUrl}/services/users/me/lists/${e}`,"PATCH",JSON.stringify(t),{"Content-Type":h})}async deleteList(e){return this.fetchEndpoint(`${this.baseUrl}/services/users/me/lists/${e}`,"DELETE")}async addMemberToList(e,t){return this.fetchEndpoint(`${this.baseUrl}/services/users/me/lists/${e}/members`,"POST",JSON.stringify(t),{"Content-Type":h})}async removeMemberFromList(e,t){return this.fetchEndpoint(`${this.baseUrl}/services/users/me/lists/${e}/members/${t}`,"DELETE")}async removeBulkMembersFromList(e,t){return this.fetchEndpoint(`${this.baseUrl}/services/users/me/lists/${e}/members`,"PATCH",JSON.stringify({remove:t}),{"Content-Type":h})}static getErrorResult(e,t){return new m(e,n.getErrorMessage(t),{cause:t})}static getErrorMessage(e){return e instanceof Error?e.message:typeof e=="string"?e:"Unknown error"}};v.DEFAULT_BASE_URL="https://archive.org";var c=class extends D{async saveListDetails(e){var t,r,i,s;e.preventDefault();let a=(t=e.target)===null||t===void 0?void 0:t.querySelector("button#save-list-settings");a?.setAttribute("disabled","true"),this.dispatchEvent(new Event("userListSaving"));try{let l={list_name:this.listName.value,description:this.listDescription.value,is_private:this.listPrivate.checked},d;if(!((r=this.userList)===null||r===void 0)&&r.id?d=await((i=this.userListsService)===null||i===void 0?void 0:i.updateList(this.userList.id,l)):d=await((s=this.userListsService)===null||s===void 0?void 0:s.createList(l)),d.success)this.dispatchEvent(new CustomEvent("userListSaved",{detail:d.success}));else throw d.error}catch(l){this.dispatchEvent(new CustomEvent("userListError",{detail:{error:l}})),console.log("error",l),a?.removeAttribute("disabled")}}emitCloseModalEvent(e){e.preventDefault(),this.dispatchEvent(new Event("listModalClosed"))}render(){var e,t,r,i,s,a,l,d;return F`
      <section class="new-list">
        <form id="user-list-form" @submit=${this.saveListDetails}>
          <div class="field">
            <input type="hidden" id="id" .value=${(t=(e=this.userList)===null||e===void 0?void 0:e.id)!==null&&t!==void 0?t:""} />
            <label for="name">List name*</label>
            <input
              type="text"
              id="name"
              .value=${(i=(r=this.userList)===null||r===void 0?void 0:r.list_name)!==null&&i!==void 0?i:""}
              required
            />
          </div>
          <div class="field">
            <label for="description">Description</label>
            <textarea
              id="description"
              .value=${(a=(s=this.userList)===null||s===void 0?void 0:s.description)!==null&&a!==void 0?a:""}
            ></textarea>
          </div>
          <div class="field">
            <label for="private">Private list</label>
            <input
              type="checkbox"
              id="private"
              .checked="${(d=(l=this.userList)===null||l===void 0?void 0:l.is_private)!==null&&d!==void 0?d:!1}"
            />
          </div>
          <div class="footer field">
            <button
              type="button"
              class="ia-button dark"
              id="cancel"
              @click=${this.emitCloseModalEvent}
            >
              Cancel
            </button>
            <button
              type="submit"
              id="save-list-settings"
              class="ia-button primary"
            >
              Save
            </button>
          </div>
        </form>
      </section>
    `}};c.styles=[$,R`
      :host {
        display: block;
        padding: 15px 0 0 0;
        font-size: 14px;
        position: relative;
      }

      .field {
        margin-bottom: 10px;
        display: flex;
        align-items: center;
      }

      label {
        display: inline-block;
        width: 90px;
        text-align: left;
        margin-right: 10px;
        font-weight: 700;
      }

      input[type='text'],
      textarea {
        line-height: 20px;
        padding: 5px;
        border-radius: 5px;
        width: 270px;
        font-family: inherit;
        font-size: inherit;
        resize: none;
        border-style: solid;
        outline: none;
        border-radius: 4px;
        border-width: 1px;
        border-color: #999;
      }

      input[type='checkbox'] {
        cursor: pointer;
        margin: 0;
      }

      label[for='private'] {
        cursor: pointer;
      }

      .footer {
        display: block;
        text-align: center;
        margin: 10px 0 0 0;
      }

      .ia-button {
        display: initial;
        padding: 0 15px;
        height: 3.5rem;
      }
    `];p([T({type:Object}),b("design:type",Object)],c.prototype,"userList",void 0);p([T({type:Object}),b("design:type",v)],c.prototype,"userListsService",void 0);p([f("#id"),b("design:type",HTMLInputElement)],c.prototype,"listId",void 0);p([f("#name"),b("design:type",HTMLInputElement)],c.prototype,"listName",void 0);p([f("#description"),b("design:type",HTMLInputElement)],c.prototype,"listDescription",void 0);p([f("#private"),b("design:type",HTMLInputElement)],c.prototype,"listPrivate",void 0);c=p([M("iaux-userlist-settings")],c);export{c as IAUserListSettings,m as UserListsError,u as UserListsErrorReason,v as UserListsService};
//# sourceMappingURL=ia-userlist-settings.mjs.map